import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, NgForm } from '@angular/forms';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'datasource-agent-proxy-html',
  templateUrl: './datasource.agent.proxy.html',
  providers: [],
  styleUrls: ['../datasource.style.scss']
})
export class DatasourceAgentProxyComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  hide = true;

  constructor(private readonly formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.step.form = this.form;
  }
}
